<template>
  <BaseDialog
    title="Vehicle Type"
    width="800"
    v-model="openVehicleTypeDialog"
    :btnEnable="true"
    @reset="resetForm"
  >
    <template #information>
      <v-form v-model="isValid" ref="vehicleType" class="pt-5">
        <v-row>
          <v-col cols="12" lg="8">
            <InputField
              id="name"
              v-model="vehicleTypeDetails.name"
              name="name"
              label=" Name"
              required
              :error-messages="formErrors.name"
              @input="delete formErrors.name"
            />
          </v-col>
          <v-col cols="12" lg="4"></v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="length"
              type="number"
              step="0.0001"
              min="0.0001"
              name="length"
              v-model="vehicleTypeDetails.length"
              label="Length"
              :suffix="UOM.CM"
              :required="true"
              :rules="[(val) => val > 0 || 'Negative Numbers are not allowed']"
              :error-messages="formErrors.length"
              @input="delete formErrors.length"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="width"
              type="number"
              step="0.0001"
              min="0.0001"
              v-model="vehicleTypeDetails.width"
              name="width"
              label="Width"
              :suffix="UOM.CM"
              :required="true"
              :rules="[(val) => val > 0 || 'Negative Numbers are not allowed']"
              :error-messages="formErrors.width"
              @input="delete formErrors.width"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="height"
              type="number"
              step="0.0001"
              min="0.0001"
              v-model="vehicleTypeDetails.height"
              name="height"
              label="Height"
              :suffix="UOM.CM"
              :required="true"
              :rules="[(val) => val > 0 || 'Negative Numbers are not allowed']"
              :error-messages="formErrors.height"
              @input="delete formErrors.height"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="tonnageCapacity"
              type="number"
              name="tonnage_capacity"
              min="0.0001"
              step="0.0001"
              v-model="vehicleTypeDetails.tonnage_capacity"
              label="Tonnage Capacity"
              :suffix="UOM.KG"
              :required="true"
              :rules="[(val) => val > 0 || 'Negative Numbers are not allowed']"
              :error-messages="formErrors.tonnage_capacity"
              @input="delete formErrors.tonnage_capacity"
            />
          </v-col>
          <v-col cols="12" lg="4">
            <InputField
              id="cbmCapacity"
              type="number"
              name="cbm_capacity"
              step="0.0001"
              min="0.0001"
              v-model="vehicleTypeDetails.cbm_capacity"
              label="CBM Capacity"
              :suffix="UOM.CBM"
              :required="true"
              :rules="[(val) => val > 0 || 'Negative Numbers are not allowed']"
              :error-messages="formErrors.cbm_capacity"
              @input="delete formErrors.cbm_capacity"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #action>
      <SecondaryButton
        id="projectReset"
        @click="resetForm()"
        v-if="!editMode"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="projectSubmit"
        :disabled="!isValid"
        @click="submitForm()"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
      >
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { UOM } from "@/utils/fieldConstants";
export default {
  components: {
    BaseDialog,
  },
  props: {
    value: Boolean,
    editMode: {
      default: false,
    },
    objectID: {
      type: [String, Number],
    },
  },
  data() {
    return {
      UOM,
      isValid: false,
      vehicleTypeDetails: {},
      formErrors: {},
    };
  },
  computed: {
    openVehicleTypeDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    objectID(val) {
      if (val && this.editMode) {
        this.getVehicleTypeObject(val);
      }
    },
  },
  methods: {
    resetForm() {
      this.vehicleTypeDetails = {};
      this.$refs.vehicleType.reset();
      this.$emit("reset");
    },
    getVehicleTypeObject(id) {
      this.$api.vehicleType
        .getVehicleTypeObject(id)
        .then((res) => {
          this.vehicleTypeDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submitForm() {
      if (this.editMode) {
        this.$api.vehicleType
          .updateVehicleType(this.vehicleTypeDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Vehicle Type Updated Successfully",
              color: "success",
            });
            this.resetForm();
            this.openVehicleTypeDialog = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            console.error(err);
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      } else {
        this.$api.vehicleType
          .createVehicleType(this.vehicleTypeDetails)
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Vehicle Type created Successfully",
              color: "success",
            });
            this.resetForm();
            this.openVehicleTypeDialog = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            console.error(err);
            if (err.data) {
              this.formErrors = err.data;
            }
          });
      }
    },
  },
};
</script>

<style>
</style>